let data = [
  {
    code: 'MZ',
    name: 'Mainz',
    address_1: 'Schusterstraße 42',
    address_2: '55116 Mainz',
    opening: 'Montag-Samstag 10:00 - 19:00 Uhr',
    qty: '',
  },
  {
    code: 'MS',
    name: 'Münster',
    address_1: 'Salzstraße 14-15',
    address_2: '48143 Münster',
    opening: 'Montag-Samstag 10:00 - 19:00 Uhr',
    qty: '',
  },
  {
    code: 'DA',
    name: 'Darmstadt',
    address_1: 'Luisenplatz 5, Luisencenter',
    address_2: '64283 Darmstadt',
    opening: 'Montag-Samstag 10:00 - 20:00 Uhr',
    qty: '',
  },
  {
    code: 'KO',
    name: 'Koblenz',
    address_1: 'Löhrstraße 66, Altstadt',
    address_2: '56068 Koblenz',
    opening: 'Montag-Samstag 10:00 - 19:00 Uhr',
    qty: '',
  },
  {
    code: 'K',
    name: 'Köln',
    address_1: 'Breite Straße 128-130',
    address_2: '50667 Köln',
    opening: 'Montag-Samstag 10:00 - 20:00 Uhr',
    qty: '',
  },
  {
    code: 'BN',
    name: 'Bonn',
    address_1: 'Münsterplatz 26',
    address_2: '53111 Bonn',
    opening: 'Montag-Samstag 10:00 - 20:00 Uhr',
    qty: '',
  },
  {
    code: 'HD',
    name: 'Heidelberg',
    address_1: 'Hauptstraße 91',
    address_2: '69117 Heidelberg',
    opening: 'Montag-Samstag 10:00 - 20:00 Uhr',
    qty: '',
  },
  {
    code: 'MTZ',
    name: 'Frankfurt',
    address_1: 'Main-Taunus-Zentrum 1',
    address_2: '65843 Sulzbach (Taunus)',
    opening: 'Montag-Donnerstag 10:00 - 20:00 Uhr </br> Freitag-Samstag 10:00-22:00 Uhr',
    qty: '',
  },
  {
    code: 'FR',
    name: 'Freiburg',
    address_1: 'Rathausgasse 38',
    address_2: '79098 Freiburg',
    opening: 'Montag-Samstag 10:00 - 19:00 Uhr',
    qty: '',
  },
  {
    code: 'S',
    name: 'Stuttgart',
    address_1: 'Mailänder Platz 7, Milaneo',
    address_2: ' 70173 Stuttgart',
    opening: 'Montag-Freitag 10:00 - 20:00 Uhr </br> Samstag 09:30 - 20:00 Uhr',
    qty: '',
  },
  {
    code: 'M',
    name: 'München - OEZ',
    address_1: 'Hanauer Straße 68',
    address_2: '80993 München',
    opening: 'Montag-Samstag 09:30 - 20:00 Uhr',
    qty: '',
  },
  {
    code: 'N',
    name: 'Nürnberg',
    address_1: 'Karolinenstr 3',
    address_2: '90402 Nürnberg',
    opening: 'Montag-Samstag 10:00 - 20:00 Uhr',
    qty: '',
  },
  {
    code: 'DO',
    name: 'Dortmund',
    address_1: 'Westenhellweg 11-13',
    address_2: '44137 Dortmund',
    opening: 'Montag-Samstag 10:00 - 20:00 Uhr',
    qty: '',
  },
  {
    code: 'B',
    name: 'Berlin',
    address_1: 'Münzstraße 18',
    address_2: '10178 Berlin',
    opening: 'Montag-Samstag 10:30 - 20:00 Uhr',
    qty: '',
  },
  {
    code: 'D',
    name: 'Düsseldorf',
    address_1: 'Münsterpl. 26',
    address_2: '53111 Bonn',
    opening: 'Montag-Samstag 10:00 - 20:00 Uhr',
    qty: '',
  },
];

function setNamePriceImageOnLoad() {
  const productTitle = document.querySelector('.product__info-wrapper .product__title>h1').textContent;
  document.querySelector('.available-item__name_LUA').innerText = productTitle;

  let price = document
    .querySelector('.product__info-wrapper .price__regular .price-item.price-item--regular')
    .textContent.trim();
  price = price.replace('€', '');
  price = `${price}€`;
  document.querySelector('.product-option-price').innerText = price;

  const image = document.querySelector('.product__media-item img').src;
  document.querySelector('.available-item__image').src = image;
  console.log('setNamePriceImageOnLoad');
}

function drawerCallback() {
  document.querySelector('availaility-drawer').classList.add('active', 'animate');
  document.body.classList.add('overflow-hidden-LUA-220');
  document.querySelector('.section-header').classList.add('LUA-220-header-sticky', 'animate');
  let url = window.location.href;
  gtag('event', 'storeavailability_link_click', {
    target_element: url,
  });

  const drawerElement = document.querySelector('availaility-drawer');
  const variantID = document.querySelector('.product__info-container form.normal-form input[name="id"]').value;
  const variantSku = drawerElement.getSku(variantID);
  drawerElement.fetchStoreData(variantSku);
}

function varaintSlectionCallback() {
  document.querySelector('.available-item__image').style.opacity = 0;
  setTimeout(() => {
    document.querySelector('availaility-drawer').variantSelection();
  }, 200);
}

function el220() {
  document.querySelector('.availability__wrap').addEventListener('click', drawerCallback);
  document.querySelector('.availability__image img').addEventListener('click', drawerCallback);
  document.querySelectorAll('variant-radios label').forEach((item) => {
    item.addEventListener('click', varaintSlectionCallback);
  });
  document.body.addEventListener('click', function (event) {
    if (
      !event.target.matches('.custom-dropdown input') &&
      !event.target.matches('.custom-dropdown .arrow-icon') &&
      !event.target.matches('.custom-dropdown .arrow-icon svg')
    ) {
      var dropdownContent = document.getElementById('dropdownContent');
      if (dropdownContent.classList.contains('d-block')) {
        dropdownContent.classList.remove('d-block');
        document.querySelector('.custom-dropdown input').classList.remove('active');
        document.querySelector('.arrow-icon svg').classList.remove('flip');
      }
    }
  });
}

function init220() {
  setNamePriceImageOnLoad();
  el220();
  console.log('init220 loaded');
}

class AvailailityDrawer extends HTMLElement {
  constructor() {
    super();
    const variantID = document.querySelector('.product__info-container form.normal-form input[name="id"]').value;
    const intialSku = this.getSku(variantID);
    document.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#AvailailityDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.querySelector('.drawer__close').addEventListener('click', this.close.bind(this));
  }
  //closing the drawer
  close() {
    this.classList.remove('active');
    this.classList.remove('animate');

    document.body.classList.remove('overflow-hidden-LUA-220');
    document.querySelector('.section-header').classList.remove('LUA-220-header-sticky');
  }

  //fetch the store data from api
  fetchStoreData(variantSku) {
    let apiUrl = `https://europe-west3-lua-options-app.cloudfunctions.net/store-inventory?sku=${variantSku}`;
    fetch(apiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((responseData) => {
        if (Array.isArray(responseData) && responseData.length > 0) {
          document.querySelector('.availability').classList.add('active');
          this.dataProcess(responseData);
          this.dropdownContent(responseData);
          this.querySelector('#customInput').disabled = false;
          let code = localStorage.getItem('selectedStore');
          if (code) {
            const findStore = responseData.find((store) => code == store.location);
            if (findStore) {
              this.resortStore(code);
              var storeName = this.querySelector(`.availaility__store[data-code="${code}"] .store__name`);
              this.querySelector('#customInput').value = storeName.textContent;
            }
          }
        }
      });
  }

  // dynamic dropdown
  dropdownContent(responseData) {
    let storeData = responseData;
    let dropdownContent = this.querySelector('#dropdownContent');
    dropdownContent.innerHTML = '';
    let aTags = [];
    data.forEach((item) => {
      storeData.forEach((store) => {
        if (store.location === item.code) {
          let aTag = `<a onclick="this.closest('availaility-drawer').selectValue(event)" data-value="${item.code}">${item.name}</a>`;
          aTags.push(aTag);
        }
      });
    });
    aTags.sort(function (a, b) {
      const textA = a.match(/>(.*?)</)[1];
      const textB = b.match(/>(.*?)</)[1];
      return textA.localeCompare(textB);
    });

    aTags.forEach(function (aTag) {
      dropdownContent.insertAdjacentHTML('beforeend', aTag);
    });
  }

  //process the data and display it in the drawer
  dataProcess(responseData) {
    let greenImg = 'https://cdn.shopify.com/s/files/1/2129/9453/files/Ellipse_1.svg?v=1707817757';
    let yellowImg = 'https://cdn.shopify.com/s/files/1/2129/9453/files/almost.svg?v=1708603281';
    let redImg = 'https://cdn.shopify.com/s/files/1/2129/9453/files/Ellipse_1_1.svg?v=1707817757';
    let storeData = responseData;
    let filteredData = data.filter((item) => storeData.some((store) => store.location === item.code));
    let storeDataFiltered = filteredData.map((store) => {
      let matchingItem = storeData.find((item) => item.location === store.code);
      if (matchingItem) {
        store.qty = matchingItem.qty;
      }
      return store;
    });

    let filterByAvailable = storeDataFiltered.filter((store) => store.qty >= 5);
    let storeDataSortedByName_1 = filterByAvailable.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
    let filterByAlmostOut = storeDataFiltered.filter((store) => store.qty < 5 && store.qty > 0);
    let storeDataSortedByName_2 = filterByAlmostOut.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });

    let filterByAUnavailable = storeDataFiltered.filter((store) => store.qty <= 0);
    let storeDataSortedByName_3 = filterByAUnavailable.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
    let finalData = storeDataSortedByName_1.concat(storeDataSortedByName_2, storeDataSortedByName_3);

    let availableStore = finalData.filter((store) => store.qty > 0);
    availableStore = availableStore.length;

    let availableStoreMsg =
      availableStore > 0 ? `In ${availableStore} Stores verfügbar` : `Zurzeit in keinem Store verfügbar`;

    document.querySelector('.availaility_store_count p').textContent = `${availableStoreMsg}`;
    document.querySelector('.availaility__store_wrap').innerHTML = '';

    let storeDataSortedFilteredHtml = finalData
      .map((store) => {
        let imgSrc, stockMessage;
        if (store.qty < 5 && store.qty != 0) {
          stockMessage = 'Geringer Bestand';
          imgSrc = yellowImg;
        } else if (store.qty == 0 || store.qty < 0) {
          stockMessage = 'Zurzeit nicht verfügbar';
          imgSrc = redImg;
        } else if (store.qty >= 5) {
          stockMessage = 'Verfügbar';
          imgSrc = greenImg;
        }
        return `
          <div class="availaility__store" data-code="${store.code}" data-name="${store.name}" data-qty="${store.qty}">
              <div class="availaility__store__contact">
                  <p class="store__availaility"><img src="${imgSrc}"><span>${stockMessage}</span></p>
                  <p class="store__name">${store.name}</p>
                  <p class="store__address_1">${store.address_1}</p>
                  <p class="store__address_2">${store.address_2}</p>
              </div>
              <div class="availaility__store__office">
                  <p class="office__name">Öffnungszeiten:</p>
                  <p class="office__hourse">${store.opening}</p>
              </div>
          </div>
      `;
      })
      .join('');
    document.querySelector('.availaility__store_wrap').insertAdjacentHTML('beforeend', storeDataSortedFilteredHtml);
  }

  // Toggle the visibility of the dropdown content
  toggleDropdown() {
    let input = this.querySelector('#customInput');
    input.classList.toggle('active');
    this.querySelector('.arrow-icon svg').classList.toggle('flip');
    this.querySelector('#dropdownContent').classList.toggle('d-block');
  }

  // Select and display the chosen value
  filterOptions() {
    var input,
      filter,
      options,
      i,
      txtValue,
      count = 0,
      hiddenLinks;
    input = document.getElementById('customInput');
    input.textContent = '';
    filter = input.value.toUpperCase();
    options = this.querySelectorAll('#dropdownContent a');

    for (i = 0; i < options.length; i++) {
      txtValue = options[i].textContent || options[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        options[i].style.display = 'flex';
      } else {
        options[i].style.display = 'none';
      }
    }

    // Show the dropdown content
    this.querySelector('#dropdownContent').classList.add('d-block');
    if (this.querySelector('#dropdownContent').classList.contains('d-block') && !this.querySelector('.flip')) {
      this.querySelector('.arrow-icon svg').classList.add('flip');
      input.classList.add('active');
    }
    hiddenLinks = Array.from(this.querySelectorAll('#dropdownContent a')).filter(
      (item) => item.style.display === 'none'
    );
    count = hiddenLinks.length;
    if (count === 9) {
      this.querySelector('.dropdown-content').style.border = 'unset';
    } else {
      this.querySelector('.dropdown-content').style.border = '1px solid rgba(18, 18, 18, 0.08)';
    }
  }

  // Select and display the chosen value
  selectValue(e) {
    var customInput = this.querySelector('#customInput');
    customInput.value = e.target.textContent;
    customInput.classList.remove('active');
    this.querySelector('.arrow-icon svg').classList.remove('flip');
    this.querySelector('#dropdownContent').classList.remove('d-block');
    this.querySelectorAll('#dropdownContent a').forEach((item) => {
      item.style.display = 'flex';
    });

    let code = e.target.getAttribute('data-value');
    localStorage.setItem('selectedStore', code);
    this.resortStore(code);
  }

  // Resort the store
  resortStore(code) {
    let moreStore = `
          <div class="availaility_store_more">
              <p>Weitere Stores</p>
          </div>
       `;
    let storeData = this.querySelectorAll('.availaility__store');
    let filterByAvailable = Array.from(storeData).filter((store) => store.getAttribute('data-qty') >= 5);
    let storeDataSortedByName_1 = filterByAvailable.sort((a, b) => {
      return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'));
    });
    let filterByAlmostOut = Array.from(storeData).filter(
      (store) => store.getAttribute('data-qty') < 5 && store.getAttribute('data-qty') > 0
    );
    let storeDataSortedByName_2 = filterByAlmostOut.sort((a, b) => {
      return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'));
    });
    let filterByUnavailable = Array.from(storeData).filter((store) => store.getAttribute('data-qty') <= 0);
    let storeDataSortedByName_3 = filterByUnavailable.sort((a, b) => {
      return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'));
    });
    let finalData = storeDataSortedByName_1.concat(storeDataSortedByName_2, storeDataSortedByName_3);
    let matchingIndex = finalData.findIndex((item) => item.getAttribute('data-code') === code);
    if (matchingIndex !== -1) {
      let matchingElement = finalData.splice(matchingIndex, 1)[0];
      finalData.unshift(matchingElement);
    }
    this.querySelector('.availaility__store_wrap').innerHTML = '';
    finalData.forEach((store, index) => {
      this.querySelector('.availaility__store_wrap').insertAdjacentElement('beforeend', store);
      if (index == 0) {
        this.querySelector('.availaility_store_count').classList.add('active');
        this.querySelector('.availaility_store_count p').textContent = `Dein bevorzugter Store`;
        if (this.querySelector('.availaility_store_more')) {
          this.querySelector('.availaility_store_more').remove();
        }
        store.insertAdjacentHTML('afterend', moreStore);
      }
    });
  }

  //find Sku
  getSku(variantID) {
    const variant = meta.product.variants.find((item) => item.id == variantID);
    return variant.sku;
  }
  // get price
  getPrice(variantID) {
    const variant = meta.product.variants.find((item) => item.id == variantID);
    const formattedPrice = (variant.price / 100).toFixed(2);
    if (document.body.classList.contains('LUA-213__v1')) {
      return `${formattedPrice}`;
    } else if (document.body.classList.contains('LUA-213__v2')) {
      return `${formattedPrice}€`;
    }
    return `€${formattedPrice}`;
  }

  //variantSelection
  variantSelection() {
    const variantID = document.querySelector('.product__info-container form.normal-form input[name="id"]').value;
    const variantSku = this.getSku(variantID);
    this.fetchStoreData(variantSku);
    const image = document.querySelector('.product__media-item img').src;
    document.querySelector('.available-item__image').src = image;
    document.querySelector('.available-item__image').style.opacity = 1;
    document.querySelector('.available-item__details .product-option-price').textContent = this.getPrice(variantID);
  }
}
customElements.define('availaility-drawer', AvailailityDrawer);

document.addEventListener('DOMContentLoaded', function () {
  init220();
});
